const customColor = (record, theme = 'light') => {
  const isDarkMode = theme === 'dark'
  let textColor = isDarkMode ? '#E0E0E0' : '#121212'
  const bgColor = 'transparent'
  let stateBarColor = null
  const isLocked = !!record?.stop_rgpd

  const hasStatuses = record?.center_id !== '9e9389ba-ddb3-3d97-4439-b217ace5ec63' &&
                      record?.status_inscription_ids &&
                      record?.status_inscription_ids !== '' &&
                      record?.status_inscription_ids?.length > 0

  switch (true) {
    case hasStatuses:
      stateBarColor = isDarkMode ? '#2e8b57' : '#1b6b3a'
      break
    case record?.candidat:
      stateBarColor = isDarkMode ? '#4a9ec4' : '#2c7da0'
      break
    case record?.not_interested:
      // textColor = isDarkMode ? '#ff5e5e' : '#d11b1b'
      stateBarColor = isDarkMode ? '#f89292' : '#f57a7a'
      break
    case record?.interested:
      stateBarColor = isDarkMode ? '#6aaf7e' : '#4a8f5e'
      break
  }

  if (isLocked) {
    stateBarColor = isDarkMode ? '#e06050' : '#c84637'
  }

  return { textColor, bgColor, stateBarColor, isLocked }
}

export default customColor
